import { useQuery } from "react-query";
import { getScheduledDeactivation } from "api/customers";
import { STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";

export interface ScheduledDeactivationData {
  scheduled_deactivation_date: string;
  drop_reason?: string;
  churn_reason?: string;
  departed_to?: string;
  note?: string;
  deactivation_status: "processing" | "processed";
}

export interface UseScheduledDeactivationOptions {
  clientId: string;
  enabled?: boolean;
}

/**
 * Hook to fetch scheduled deactivation data for a client
 * When confirming a scheduled deactivation, the frontend calls the regular
 * deactivateClient endpoint with the stored data and today's date.
 * Since it's not in the future, it executes the immediate deactivation flow.
 */
export const useGetScheduledDeactivation = ({
  clientId,
  enabled = true,
}: UseScheduledDeactivationOptions) => {
  return useQuery(
    ["scheduledDeactivation", clientId],
    async () => {
      if (!clientId) return null;
      const response = await getScheduledDeactivation(clientId);
      return response.data;
    },
    {
      enabled: enabled && !!clientId,
      staleTime: STALE_TIME_5_MINUTES, // 5 minutes
    }
  );
};
